import type { FunctionComponent } from 'react';
import Modal from 'react-modal';
import { Disclaimer, DISCLAIMER_NAMES } from '@fff-web/cms';
import { useUserContext } from '@fff-web/fff-utilities';
import env from '../../config/env';
import CloseButton from '../commons/close-button';
import * as styles from './SeeDetailsModal.module.css';

interface SeeDetailsModalType {
  closeAction: () => void;
}

const SeeDetailsModal: FunctionComponent<SeeDetailsModalType> = ({ closeAction }) => {
  const { userInfo } = useUserContext();
  const disclaimerName =
    userInfo?.user?.role === 'SELECT'
      ? DISCLAIMER_NAMES.swapForCreditAnnual
      : DISCLAIMER_NAMES.swapForCreditSeasonal;

  return (
    <Modal
      isOpen
      overlayClassName={styles.modalOverlay}
      className={styles.modalWrapper}
      shouldCloseOnOverlayClick
      onRequestClose={closeAction}
    >
      <div className={styles.modalContainer}>
        <CloseButton onClick={closeAction} />
        <div className={styles.legal} data-testid={`${disclaimerName}-disclaimer`}>
          <Disclaimer name={disclaimerName} env={env.ENVIRONMENT} />
        </div>
      </div>
    </Modal>
  );
};

export default SeeDetailsModal;
